import { Link } from 'react-router-dom';

export default function BrandHeader() {
  return (
    <header className="bg-navy text-white">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="bg-crimson w-1.5 h-7 rounded-sm" aria-hidden />
          <span className="font-bold tracking-tight text-lg leading-none">
            ASE CRM
          </span>
        </Link>
        <span className="hidden sm:block text-xs uppercase tracking-[0.18em] text-navy-100/80">
          ASE
        </span>
      </div>
    </header>
  );
}
